import axios, { AxiosError, AxiosResponse } from "axios";
import { logger } from "@caju-beneficios/monitoring";

export const CajuClient = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL_API,
});

CajuClient.interceptors.response.use(
  (response: AxiosResponse) => response,
  (error: AxiosError) => {
    logger.error({
      message: "API request failed",
      error,
      context: {
        application: "quero-caju",
        url: error.config?.url,
        method: error.config?.method,
        status: error.response?.status,
        statusText: error.response?.statusText,
        baseURL: error.config?.baseURL,
      },
    });

    return Promise.reject(error);
  }
);
